module.exports = __webpack_public_path__ + "img/about-top.afbbc722.png";